import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BookingSummaryItem } from '../../common/items/BookingSummaryItem';

export const BookingSummaryAlcohol = ({ currentBooking, pendingBooking }) => {
  const alcoholUpdated =
    !isEmpty(pendingBooking) &&
    currentBooking.alcohol_consumed !== pendingBooking.alcohol_consumed;

  const yesText = (
    <FormattedMessage
      id='inbox.summary_props.alcohol_consumption_yes'
      defaultMessage='Yes'
    />
  );
  const noText = (
    <FormattedMessage
      id='inbox.summary_props.alcohol_consumption_no'
      defaultMessage='No'
    />
  );

  return (
    <BookingSummaryItem
      testingId='booking-summary-alcohol'
      label={
        <FormattedMessage
          id='inbox.summary_props.alcohol_consumption'
          defaultMessage='Alcohol consumption'
        />
      }
      updatedContent={
        alcoholUpdated && (pendingBooking.alcohol_consumed ? yesText : noText)
      }
    >
      {currentBooking.alcohol_consumed ? yesText : noText}
    </BookingSummaryItem>
  );
};

BookingSummaryAlcohol.propTypes = {
  currentBooking: PropTypes.object.isRequired,
  pendingBooking: PropTypes.object
};
